import { Text } from "@overmap-ai/blocks"
import type { FormSubmission, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { FormSubmissionListItem } from "./FormSubmissionListItem"

interface FormSubmissionListProps {
	formSubmissions: Stored<FormSubmission>[]
	onClickFormSubmission: (formSubmission: Stored<FormSubmission>) => void
	onViewFormSubmission: (formSubmission: Stored<FormSubmission>) => void
	onUnlinkFormSubmission: (formSubmission: Stored<FormSubmission>) => void
	onDeleteFormSubmission: (formSubmission: Stored<FormSubmission>) => void
}

export const FormSubmissionList = memo<FormSubmissionListProps>((props) => {
	const {
		formSubmissions,
		onClickFormSubmission,
		onViewFormSubmission,
		onUnlinkFormSubmission,
		onDeleteFormSubmission,
	} = props

	return formSubmissions.length > 0 ? (
		<ol className="flex flex-col gap-2" role="list">
			{formSubmissions.map((formSubmission) => (
				<FormSubmissionListItem
					key={formSubmission.uuid}
					formSubmission={formSubmission}
					onClick={onClickFormSubmission}
					onView={onViewFormSubmission}
					onUnlink={onUnlinkFormSubmission}
					onDelete={onDeleteFormSubmission}
				/>
			))}
		</ol>
	) : (
		<Text accentColor="base" size="sm" weight="regular">
			No forms.
		</Text>
	)
})
FormSubmissionList.displayName = "FormSubmissionList"
